// extracted by mini-css-extract-plugin
module.exports = {"container":"_2_7S4oRbR1tBfRMxmsWTNy","item":"_2qCO_JeUgzovySTo-naWgN","dot":"_21IyeQV6AixPAKUZM01kFH"};